<template>
  <div class="virtual-contract-manage-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>注册合同查询</span>
            <div>
              <!-- 新增导出按钮，对齐车位页面样式 -->
              <el-button
                type="primary"
                size="small"
                @click="exportWork"
                style="margin-right: 10px"
              >
                <i class="el-icon-download"></i>
                导出
              </el-button>
              <el-button
                type="success"
                size="small"
                @click="handleImport"
              >
                <i class="el-icon-upload2"></i>
                导入
              </el-button>
              <!-- 批量操作按钮已注释 -->
            </div>
          </div>
          <el-form
            :inline="true"
            :model="searchForm"
            class="search-form text-left"
          >
            <el-form-item>
              <el-input
                v-model="searchForm.companyName"
                placeholder="请输入公司名称"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="searchForm.name"
                placeholder="请输入姓名"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="searchForm.phone"
                placeholder="请输入联系方式"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="searchForm.contractDate"
                type="month"
                placeholder="选择合同月份"
                format="yyyy-MM"
                value-format="yyyy-MM"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch"> 查询 </el-button>
              <el-button @click="handleReset"> 重置 </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>注册合同列表</span>
            <el-button
              type="primary"
              size="small"
              style="float: right"
              @click="handleAdd"
            >
              新增
            </el-button>
          </div>
          <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="companyName"
              label="公司名称"
              align="center"
            />
            <el-table-column
              prop="registerAddress"
              label="注册地址"
              align="center"
            />
            <el-table-column prop="name" label="姓名" align="center" />
            <el-table-column prop="phone" label="联系方式" align="center" />
            <el-table-column
              prop="legalIdCard"
              label="法人身份证"
              align="center"
            />
            <el-table-column
              prop="contractDate"
              label="合同日期"
              align="center"
            />
            <el-table-column label="附件" align="center" width="120">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="handleAttachment(scope.row)"
                  v-if="
                    scope.row.attachment && scope.row.attachment.trim() !== ''
                  "
                >
                  上传/查看
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleAttachment(scope.row)"
                  v-else
                >
                  上传
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleDownloadAttachment(scope.row)"
                  v-if="
                    scope.row.attachment && scope.row.attachment.trim() !== ''
                  "
                >
                  下载
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="page.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page.size"
            :total="page.total"
            layout="total, sizes, prev, pager, next, jumper"
            style="margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </el-col>
    </el-row>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="form.id ? '编辑虚拟合同' : '新增虚拟合同'"
      :visible.sync="formVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="120px"
        label-position="right"
      >
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="form.companyName" placeholder="请输入公司名称" />
        </el-form-item>
        <el-form-item label="注册地址" prop="registerAddress">
          <el-input
            v-model="form.registerAddress"
            type="textarea"
            placeholder="请输入注册地址"
          />
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入联系方式" />
        </el-form-item>
        <el-form-item label="法人身份证" prop="legalIdCard">
          <el-input
            v-model="form.legalIdCard"
            placeholder="请输入法人身份证号"
          />
        </el-form-item>
        <el-form-item label="合同日期" prop="contractDate">
          <el-date-picker
            v-model="form.contractDate"
            type="month"
            placeholder="选择合同月份"
            format="yyyy-MM"
            value-format="yyyy-MM"
          />
        </el-form-item>
        <el-form-item label="附件">
          <el-button type="text" @click="handleAttachment(form)">
            {{
              form.attachment && form.attachment.trim() !== ""
                ? "更换附件"
                : "上传附件"
            }}
          </el-button>
          <span
            v-if="form.attachment && form.attachment.trim() !== ''"
            class="attachment-tip"
          >
            已上传：{{ getFileName(form.attachment) }}
          </span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog
      title="删除虚拟合同"
      :visible.sync="deleteVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px 0; text-align: center" v-if="!isBatchDelete">
        <i class="el-icon-warning" style="color: #e6a23c; font-size: 24px"></i>
        <p style="margin-top: 10px">确定要删除该虚拟合同吗？</p>
        <p style="color: #999; font-size: 12px">删除后将无法恢复，请谨慎操作</p>
      </div>
      <div style="padding: 20px 0; text-align: center" v-if="isBatchDelete">
        <i class="el-icon-warning" style="color: #e6a23c; font-size: 24px"></i>
        <p style="margin-top: 10px">
          确定要批量删除选中的{{ selectedIds.length }}条合同吗？
        </p>
        <p style="color: #999; font-size: 12px">删除后将无法恢复，请谨慎操作</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmDelete">确定删除</el-button>
      </div>
    </el-dialog>

    <!-- 附件上传弹窗 -->
    <el-dialog
      title="上传合同附件"
      :visible.sync="attachmentVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-upload
        class="upload-demo"
        drag
        action="/callComponent/upload/uploadFile/uploadImage"
        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
        :limit="1"
        name="uploadFile"
        :data="uploadExtraParams"
        :file-list="fileList"
        :on-success="handleUploadSuccess"
        :on-remove="handleRemove"
        :auto-upload="true"
        :on-exceed="handleExceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          支持 PDF, Word, Excel, PPT (单个文件最大 10MB)
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="attachmentVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- Excel导入弹窗【对齐车位导入完整改造】 -->
    <el-dialog
      title="导入虚拟合同"
      :visible.sync="importVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="handleImportClose"
    >
      <el-form
        ref="importForm"
        :model="importForm"
        :rules="importRules"
        label-width="120px"
        label-position="right"
        class="text-left"
      >
        <el-form-item label="选择文件" prop="file">
          <el-upload
            ref="importUpload"
            :auto-upload="false"
            :limit="1"
            :on-change="handleFileChange"
            :on-exceed="handleFileExceed"
            :file-list="importFileList"
            accept=".xls,.xlsx"
            action=""
            :before-upload="beforeImportUpload"
            :on-remove="handleFileRemove"
          >
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">
              {{
                importFileList.length > 0
                  ? importFileList[0].name
                  : "请上传.xlsx/.xls格式文件，大小不超过10MB（仅支持单个文件）"
              }}
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="下载模板">
          <div>
            请按照模板格式填写数据后导入
            <el-link type="primary" :href="templateUrl" target="_blank">
              下载导入模板
            </el-link>
          </div>
        </el-form-item>

        <el-form-item label="字段说明">
          <el-button type="text" @click="openTemplateDescModal">
            查看字段填写说明
          </el-button>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="importVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="submitImport"
          :loading="importLoading"
        >
          确认导入
        </el-button>
      </div>
    </el-dialog>

    <!-- 导入模板字段说明弹窗 -->
    <el-dialog
      title="导入模板字段填写说明"
      :visible.sync="templateDescModalVisible"
      width="600px"
    >
      <el-table :data="templateFieldDesc" border style="width: 100%">
        <el-table-column
          prop="fieldName"
          label="字段名称"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="fieldDesc"
          label="填写说明"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="example"
          label="示例"
          align="center"
          width="200"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getContractList,
  addContract,
  editContract,
  deleteContract,
  batchDeleteContract,
  batchDownloadAttachment,
  exportVirtualContractData,
  importVirtualContractExcel
} from "@/api/contract/virtualContractApi";
import { getCommunityId } from "@/api/community/communityApi";

export default {
  name: "VirtualContractManageList",
  data() {
    return {
      loading: false,
      // 搜索表单
      searchForm: {
        companyName: "",
        name: "",
        phone: "",
        contractDate: "",
      },
      // 表格数据
      tableData: [],
      // 分页参数
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      // 选中的ID列表（批量操作）
      selectedIds: [],
      // 表单弹窗相关
      formVisible: false,
      form: {
        id: "",
        companyName: "",
        registerAddress: "",
        name: "",
        phone: "",
        legalIdCard: "",
        contractDate: "",
        attachment: "",
      },
      rules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        contractDate: [
          { required: true, message: "请选择合同日期", trigger: "change" },
        ],
      },
      // 删除弹窗相关
      deleteVisible: false,
      deleteRow: {},
      isBatchDelete: false,
      // 附件上传
      attachmentVisible: false,
      attachmentRow: {},
      fileList: [],
      uploadExtraParams: {
        communityId: "",
        contractId: "",
      },
      // ========== 导入相关（完全对齐车位页面） ==========
      importVisible: false,
      importLoading: false,
      importFileList: [],
      uploadFile: null,
      templateUrl: "/import/virtualContract.xlsx",
      importForm: {
        communityId: "",
      },
      importRules: {
        file: [
          {
            required: true,
            message: "请选择要导入的Excel文件",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (this.importFileList.length === 0) {
                callback(new Error("请选择要导入的Excel文件"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      templateDescModalVisible: false,
      templateFieldDesc: [
        {
          fieldName: "公司名称",
          fieldDesc: "必填，企业全称",
          example: "长春XX商贸有限公司"
        },
        {
          fieldName: "注册地址",
          fieldDesc: "必填，工商注册地址",
          example: "长春市南关区XX街道XX号"
        },
        {
          fieldName: "法人姓名",
          fieldDesc: "必填",
          example: "李四"
        },
        {
          fieldName: "法人手机号",
          fieldDesc: "必填，11位手机号",
          example: "13500001111"
        },
        {
          fieldName: "法人身份证号",
          fieldDesc: "必填，18位身份证",
          example: "2201011990XXXXXXXXX"
        },
        {
          fieldName: "合同月份",
          fieldDesc: "必填，格式yyyy-MM",
          example: "2026-07"
        }
      ],
      communityId: "",
      progress: 0,
    };
  },
  created() {
    this.communityId = getCommunityId() || "";
    this.uploadExtraParams.communityId = this.communityId;
    this.importForm.communityId = this.communityId;
    this.getList();
  },
  methods: {
    getFileName(filePath) {
      if (!filePath || filePath.trim() === "") {
        return "附件文件";
      }
      return filePath.split("/").pop() || "附件文件";
    },

    async getList() {
      try {
        this.loading = true;
        const params = {
          page: this.page.current,
          row: this.page.size,
          companyName: this.searchForm.companyName,
          name: this.searchForm.name,
          phone: this.searchForm.phone,
          contractDate: this.searchForm.contractDate,
          communityId: this.communityId,
        };
        const res = await getContractList(params);
        if (res && res.code === 0) {
          this.tableData = res.data || [];
          this.page.total = res.total || 0;
        } else {
          this.tableData = [];
          this.page.total = 0;
          this.$message.error(res.msg || "获取列表失败");
        }
      } catch (error) {
        console.error("获取虚拟合同列表失败:", error);
        this.$message.error("获取虚拟合同列表失败，请稍后重试");
        this.tableData = [];
        this.page.total = 0;
      } finally {
        this.loading = false;
      }
    },

    handleSearch() {
      this.page.current = 1;
      this.getList();
    },

    handleReset() {
      this.searchForm = {
        companyName: "",
        name: "",
        phone: "",
        contractDate: "",
      };
      this.handleSearch();
    },

    handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },

    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },

    handleSelectionChange(val) {
      this.selectedIds = val.map((item) => item.id);
    },

    handleAdd() {
      this.form = {
        id: "",
        companyName: "",
        registerAddress: "",
        name: "",
        phone: "",
        legalIdCard: "",
        contractDate: "",
        attachment: "",
        communityId: this.communityId,
      };
      this.formVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    handleEdit(row) {
      this.form = { ...row, communityId: this.communityId };
      this.formVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();
        const submitForm = {
          ...this.form,
          communityId: this.communityId,
        };
        let res;
        if (submitForm.id) {
          res = await editContract(submitForm);
        } else {
          res = await addContract(submitForm);
        }
        if (res && res.code === 0) {
          this.$message.success(submitForm.id ? "编辑虚拟合同成功" : "新增虚拟合同成功");
          this.formVisible = false;
          this.getList();
        } else {
          this.$message.error(res.msg || (submitForm.id ? "编辑虚拟合同失败" : "新增虚拟合同失败"));
        }
      } catch (error) {
        if (error !== false) {
          console.error("提交虚拟合同失败:", error);
          this.$message.error(this.form.id ? "编辑虚拟合同失败" : "新增虚拟合同失败");
        }
      }
    },

    handleDelete(row) {
      this.deleteRow = row;
      this.isBatchDelete = false;
      this.deleteVisible = true;
    },

    handleBatchDelete() {
      this.isBatchDelete = true;
      this.deleteVisible = true;
    },

    async confirmDelete() {
      try {
        let res;
        if (this.isBatchDelete) {
          res = await batchDeleteContract(this.selectedIds);
        } else {
          res = await deleteContract({
            id: this.deleteRow.id,
            communityId: this.communityId,
          });
        }
        if (res && res.code === 0) {
          this.$message.success(this.isBatchDelete ? "批量删除成功" : "删除虚拟合同成功");
          this.deleteVisible = false;
          this.getList();
          this.selectedIds = [];
        } else {
          this.$message.error(res.msg || (this.isBatchDelete ? "批量删除失败" : "删除虚拟合同失败"));
        }
      } catch (error) {
        console.error("删除虚拟合同失败:", error);
        this.$message.error(this.isBatchDelete ? "批量删除失败" : "删除虚拟合同失败，请稍后重试");
      }
    },

    handleAttachment(row) {
      this.attachmentRow = row;
      this.uploadExtraParams.contractId = row.id || "";
      this.fileList = [];
      if (row.attachment && row.attachment.trim() !== "") {
        this.fileList = [
          {
            name: this.getFileName(row.attachment),
            url: row.attachment,
            status: "success",
          },
        ];
      }
      this.attachmentVisible = true;
    },

    handleUploadSuccess(response, file) {
      try {
        const fileUrl = response.url || (response.data && response.data.url) || "";
        if (!fileUrl) {
          this.$message.error("文件上传失败：未获取到文件地址");
          return;
        }
        file.url = fileUrl;
        this.fileList = [file];
        if (this.attachmentRow.id) {
          this.attachmentRow.attachment = fileUrl;
          if (this.form.id === this.attachmentRow.id) {
            this.form.attachment = fileUrl;
          }
        } else {
          this.form.attachment = fileUrl;
        }
        this.$message.success("附件上传成功");
        this.attachmentVisible = false;
      } catch (error) {
        console.error("处理附件上传结果失败:", error);
        this.$message.error("附件上传失败，请稍后重试");
      }
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
      const emptyAttachment = "";
      if (this.attachmentRow.id) {
        this.attachmentRow.attachment = emptyAttachment;
        if (this.form.id === this.attachmentRow.id) {
          this.form.attachment = emptyAttachment;
        }
      } else {
        this.form.attachment = emptyAttachment;
      }
      this.$message.success("附件已移除");
    },

    handleExceed(files) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`);
    },

    handleDownloadAttachment(row) {
      try {
        if (!row.attachment || row.attachment.trim() === "") {
          this.$message.warning("暂无附件可下载");
          return;
        }
        const link = document.createElement("a");
        link.href = row.attachment.startsWith("http") ? row.attachment : window.location.origin + row.attachment;
        link.download = this.getFileName(row.attachment);
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message.success("附件下载成功");
      } catch (error) {
        console.error("下载附件失败:", error);
        this.$message.error("附件下载失败，请稍后重试");
      }
    },

    async handleBatchDownload() {
      try {
        const res = await batchDownloadAttachment({
          ids: this.selectedIds,
          communityId: this.communityId,
        });
        const blob = new Blob([res.data], { type: "application/zip" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `合同附件_${new Date().getTime()}.zip`;
        link.click();
        window.URL.revokeObjectURL(link.href);
        this.$message.success("批量下载附件成功");
      } catch (error) {
        console.error("批量下载附件失败:", error);
        this.$message.error("批量下载附件失败，请稍后重试");
      }
    },

    // ==================== 导入相关方法（完全复制车位导入逻辑） ====================
    handleImport() {
      this.importVisible = true;
      this.importFileList = [];
      this.uploadFile = null;
      this.importLoading = false;
      this.$nextTick(() => {
        if (this.$refs.importForm) this.$refs.importForm.resetFields();
        if (this.$refs.importUpload) this.$refs.importUpload.clearFiles();
      });
    },

    handleImportClose() {
      this.importFileList = [];
      this.uploadFile = null;
      if (this.$refs.importForm) this.$refs.importForm.resetFields();
    },

    openTemplateDescModal() {
      this.templateDescModalVisible = true;
    },

    beforeImportUpload(file) {
      const isExcel = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ].includes(file.type);
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isExcel) {
        this.$message.error("请上传Excel格式文件（.xlsx/.xls）");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("文件大小不能超过10MB");
        return false;
      }
      return true;
    },

    handleFileExceed(files, fileList) {
      this.$message.warning(`仅支持上传1个文件，已自动忽略多余的${files.length}个文件`);
      this.importFileList = [fileList[0]];
      this.uploadFile = fileList[0].raw;
    },

    handleFileChange(file, fileList) {
      if (fileList.length > 1) fileList = [fileList[fileList.length - 1]];
      this.importFileList = fileList;
      if (fileList.length > 0) {
        this.uploadFile = file.raw;
        this.$nextTick(() => this.$refs.importForm.validateField("file"));
      } else {
        this.uploadFile = null;
      }
    },

    handleFileRemove(file, fileList) {
      this.importFileList = fileList;
      this.uploadFile = fileList.length > 0 ? fileList[0].raw : null;
      this.$refs.importForm.validateField("file");
    },

    async handleImportSuccess(res) {
      try {
        if (res && res.code === 0) {
          this.$message.success("虚拟合同导入成功");
          this.importVisible = false;
          this.getList();
        } else {
          this.$message.error(res.msg || "导入失败");
        }
      } catch (error) {
        console.error("导入失败：", error);
        this.$message.error("导入虚拟合同失败");
      }
    },

    async submitImport() {
      try {
        const valid = await new Promise((resolve) => {
          this.$refs.importForm.validate(v => resolve(v));
        });
        if (!valid) {
          this.$message.warning("请选择Excel文件再提交");
          return;
        }
        if (!this.uploadFile || this.importFileList.length === 0) {
          this.$message.error("请选择有效的Excel文件");
          return;
        }
        this.importLoading = true;
        const formData = new FormData();
        formData.append("uploadFile", this.uploadFile);
        formData.append("communityId", this.importForm.communityId);
        formData.append("importAdapt", "importVirtualContract");
        const res = await importVirtualContractExcel(formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        console.log(res,"resresresres")
        if (res.code === 0) {
          this.$message.success("导入成功");
          this.importVisible = false;
          this.getList();
        } else {
          this.$message.error(res.msg || "导入失败");
        }
      } catch (err) {
        this.$message.error(err || "导入接口异常");
        console.error("导入异常：", err);
      } finally {
        this.importLoading = false;
      }
    },

    // 导出方法
    async exportWork() {
      try {
        const useCommunityId = getCommunityId();
        const params = {
          pagePath: "listVirtualContract",
          communityId: useCommunityId,
          page: undefined,
          row: undefined,
          companyName: this.searchForm.companyName,
          name: this.searchForm.name,
          phone: this.searchForm.phone,
          contractDate: this.searchForm.contractDate
        };
        await exportVirtualContractData(params);
        this.$message.success("导出成功，请到下载中心查看");
        this.$router.push("/pages/property/downloadTempFile?tab=下载中心");
      } catch (error) {
        console.error("导出虚拟合同失败:", error);
        this.$message.error("导出失败，请稍后重试");
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.virtual-contract-manage-container {
  padding: 20px;

  .search-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-card {
    margin-bottom: 20px;
  }

  .dialog-footer {
    text-align: right;
  }

  .attachment-tip {
    margin-left: 10px;
    color: #666;
    font-size: 12px;
  }

  .upload-demo {
    width: 100%;

    .el-upload-dragger {
      width: 100%;
      height: 200px;
      line-height: 200px;
    }
  }

  ::v-deep .el-upload__tip {
    margin-top: 6px;
    font-size: 13px;
    color: #606266;
  }

  ::v-deep .el-form-item__content {
    line-height: 1.2;
  }

  ::v-deep .el-upload-dragger {
    padding: 30px 0;
  }
}
</style>